import type { AllowedTimezones, Timezone } from 'shared/lib/timezones';
import type { Payment } from 'shared/lib/payment';
import type { DBAs } from 'entities/contractor';

export interface NotificationsData {
  billingEmails: string[];
  bidEmails: string[];
  agreedToHighestBidder: boolean;
  agreedToRaiseYourBid: boolean;
  agreedToBudgetSpentEmails: boolean;
  agreedToZipExpansion: boolean;
}

export interface IssueTokenRequestModel {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface AuthenticatedManagerModel {
  id: number;
  fullName: string;
  email: string;
  hasCreditCard: boolean;
  hasArchivedInvoices: boolean;
  timezone: AllowedTimezones;
  featureFlags?: { budgetIncreaseEnabled: boolean; onboardingEnabled: boolean };
}

export type BlockingElements = 'toggle' | 'zips' | 'budget' | 'schedule';

export interface AuthenticatedContractorModel {
  id: number;
  fullName: string;
  companyName: string;
  phoneNumber: string;
  hasCreditCard: boolean;
  email: string;
  website: string;
  manager: AuthenticatedManagerModel | null;
  timezone: Timezone;
  createdAt: string;
  hasIntegrations: boolean;
  hasLeadsCampaigns: boolean;
  hasApptsCampaigns: boolean;
  hasSalesCampaigns: boolean;
  paymentMethod: Payment;
  timeLeftToBlocking: number;
  timeLeftToUnblocking: number;
  blockedElementsList: BlockingElements[];
  hasArchivedInvoices: boolean;
  lastTermsAndConditions: { version: string; isAccepted: boolean };
  featureFlags?: { budgetIncreaseEnabled?: boolean; onboardingEnabled?: boolean; holidayScheduleEnabled?: boolean };
  dbas: DBAs;
  hasThoughtspotDispositionData: boolean;
}

export interface UpdatePasswordModel {
  password: string;
  currentPassword: string;
  passwordConfirmation: string;
}

export type UpdateProfileModel = Pick<AuthenticatedContractorModel, 'fullName' | 'phoneNumber' | 'email' | 'timezone'>;

export type UpdateCampaignModel = Pick<AuthenticatedContractorModel, 'website' | 'dbas'>;

export type UpdateAcceptTermsModel = { tcVersion: string };

export const TERMS_CONDITIONS_LINK = 'https://www.homebuddy.com/terms-and-conditions';
